export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/navBack.521b3e13.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};